import { render } from "./DangCardSleeved.vue?vue&type=template&id=5221b732&scoped=true"
import script from "./DangCardSleeved.vue?vue&type=script&lang=js"
export * from "./DangCardSleeved.vue?vue&type=script&lang=js"

import "./DangCardSleeved.vue?vue&type=style&index=0&id=5221b732&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5221b732"]])

export default __exports__